export default __webpack_public_path__ + "static/media/14.d50f8ce4.gif";